import Resources from './helpers/resources'; // eslint-disable-line no-unused-vars
import { getLocale } from './i18n';

/**
 * ACTIVITY ASSIGN PREFERENCE
 */
export const getSettingPreferences = () =>
    (Resources.activityAssignPreferences)
        .get()
        .headers({ Locale: getLocale() })
        .send();

export const saveSettingPreferences = ({ request }) =>
    (Resources.activityAssignPreferences)
        .post()
        .withBody(request)
        .send();

export const getActivityAssignPreferences = () =>
    (Resources.activityAssignPreferences)
        .get()
        .headers({ Locale: getLocale() })
        .send();

export const saveActivityAssignPreferences = ({ request }) =>
    (Resources.activityAssignPreferences)
        .post()
        .withBody(request)
        .send();

export const resetActivityAssignPreferences = ({ request }) =>
    (Resources.activityAssignPreferences)
        .delete()
        .withBody(request)
        .send();

/**
 * PRIVACY SETTINGS
 */
export const getUserPortalSettings = () => (Resources.getUserPortalSettings)
    .get()
    .headers({ Locale: getLocale() })
    .send();

export const saveSchoolPreferences = (type, preferredValue) => (Resources.saveSchoolPreferences)
    .put({ type })
    .withBody({})
    .withParams({ preferredValue })
    .headers({ Locale: getLocale() })
    .send();




// WEBPACK FOOTER //
// ./app/api.js